import React from 'react'
import { Container, Card, Row, Col } from 'react-bootstrap'
import {
  formatCurrency,
  formatDateToString,
  useWindowSize,
} from '../../../helpers'
import { useSelector } from 'react-redux'
import { getCurrentResolutionBreakPoint } from 'utils/utilityFunctions'

interface IStateProps {
  downloadPdf: { isDownloading: boolean }
}
interface ICustomerRowItemProps {
  hideIfNoValue: boolean
  title: string
  isCurrency?: boolean
  value: number | string | null
}

interface IInputProps {
  data?: {
    firstName: string
    lastName: string
    address1Line1: string
    address1Line2: string
    address1City: string
    address1State: string
    address1PostCode: string
    email: string
    mobile: string
    employer: { grossAnnualSalary: number; name: string; payrollId: string }
  }
  dateOfProposalAcceptance: Date
  isProposal: boolean
  pdf: boolean
  proposalNumber: string
  title: string
}

const CustomerRowItem = (props: ICustomerRowItemProps) => {
  const isDownloadingPdf = useSelector(
    (state: IStateProps) => state.downloadPdf.isDownloading
  )
  const resolutionBreakpoint = {
    nonDesktop: getCurrentResolutionBreakPoint(isDownloadingPdf),
  }
  const [width] = useWindowSize()
  return (
    <>
      {!props.hideIfNoValue && width >= resolutionBreakpoint.nonDesktop && (
        <Row>
          <Col className="" xs={4} md={4}>
            {props.title}
          </Col>
          {props.isCurrency && (
            <Col xs={4} md={4} className="text-right">
              {formatCurrency(props.value)}
            </Col>
          )}
          {!props.isCurrency && (
            <Col xs={8} md={8} className="text-right">
              {props.value}
            </Col>
          )}
        </Row>
      )}

      {!!props.hideIfNoValue &&
        !!props.isCurrency &&
        props.value &&
        props.value > 0 &&
        width >= resolutionBreakpoint.nonDesktop && (
          <Row>
            <Col xs={4} md={4}>
              {props.title}
            </Col>
            <Col xs={8} md={8} className="text-right">
              {formatCurrency(props.value)}
            </Col>
          </Row>
        )}
      {props.hideIfNoValue &&
        !props.isCurrency &&
        props.value !== null &&
        width >= resolutionBreakpoint.nonDesktop && (
          <Row>
            <Col xs={4} md={4}>
              {props.title}
            </Col>
            <Col xs={8} md={8} className="text-right">
              {props.value}
            </Col>
          </Row>
        )}
      {props.value && width < resolutionBreakpoint.nonDesktop && (
        <>
          <Row>
            <Col>{props.title}</Col>
          </Row>
          <Row className="mb-3">
            {props.isCurrency && (
              <Col className="font-weight-normal">
                {formatCurrency(props.value)}
              </Col>
            )}
            {!props.isCurrency && (
              <Col className="font-weight-normal">{props.value}</Col>
            )}
          </Row>
        </>
      )}
    </>
  )
}

const CustomerSection = (props: IInputProps) => {
  let userName = props.data
    ? props.data.firstName + ' ' + props.data.lastName
    : null
  let getAddress = () => {
    let address = ''
    if (props.data) {
      if (props.data.address1Line1) {
        address = address + ' ' + props.data.address1Line1
      }
      if (props.data.address1Line2) {
        address = address + ' ' + props.data.address1Line2
      }
      if (props.data.address1City) {
        address = address + ' ' + props.data.address1City
      }
      if (props.data.address1State) {
        address = address + ' ' + props.data.address1State
      }
      if (props.data.address1PostCode) {
        address = address + ' ' + props.data.address1PostCode
      }
    }
    return address
  }

  return (
    <div className="card-section">
      <Container className="section mt-4">
        {props.data && (
          <Card
            className={props.pdf ? 'mb-13rem pdf-card-container' : 'mb-13rem'}
          >
            <Card.Header
              className={
                props.pdf ? 'border-bottom-0 pdf-card' : 'border-bottom-0'
              }
            >
              <div className="text-header">{props.title}</div>
            </Card.Header>
            <Card.Body>
              <CustomerRowItem
                title="Name"
                value={userName}
                hideIfNoValue={true}
              />
              <CustomerRowItem
                title="Email"
                value={props.data.email}
                hideIfNoValue={true}
              />
              <CustomerRowItem
                title="Mobile"
                value={props.data.mobile}
                hideIfNoValue={true}
              />
              {props.isProposal && props.proposalNumber && (
                <>
                  <CustomerRowItem
                    title="Proposal Number"
                    value={props.proposalNumber}
                    hideIfNoValue={true}
                  />
                </>
              )}

              {props.data.employer && (
                <>
                  <CustomerRowItem
                    title="Annual Salary"
                    value={props.data.employer.grossAnnualSalary}
                    isCurrency={true}
                    hideIfNoValue={true}
                  />
                  <CustomerRowItem
                    title="Employer"
                    value={props.data.employer.name}
                    hideIfNoValue={true}
                  />
                </>
              )}
              <CustomerRowItem
                title="Date"
                value={formatDateToString(props.dateOfProposalAcceptance)}
                hideIfNoValue={true}
              />
              <CustomerRowItem
                title="Home address"
                value={getAddress()}
                hideIfNoValue={true}
              />
              {props.data.employer && (
                <CustomerRowItem
                  title="Payroll ID"
                  value={props.data.employer.payrollId}
                  hideIfNoValue={true}
                />
              )}
            </Card.Body>
          </Card>
        )}
      </Container>
    </div>
  )
}

export default CustomerSection
